import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip } from "antd";
import "./Form.css";
import axios from "axios";
import InputForm from "./InputForm";
import ProdutoFrame from './ProdutoFrame';

const { Item: ItemForm } = Form;

export default class InventarioForm extends Component {
  state = {
    registro: {
      mi_ent_sai: '',
      mi_item: { key: '0' },
      mi_item_tamanho: 0,
      mi_item_cor: 0,
      mi_qtde: 0,
      mi_qtde_dif: 0,
      mi_vlr_unit: 0,
      mi_vlr_total: 0,
    },
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroParc !== propsAnterior.registroParc) {
      this.setState({
        registro: this.props.registroSelecionado,
      }, () => {
        // this.calculaVlrParc();
      });
    }
  }


  onOK = () => {
    this.setState({ salvando: true })

    if ((!this.state.registro.mi_item) || (this.state.registro.mi_item.key === '0') || (this.state.registro.mi_item.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe um Produto', });
      return;
    }

    if ((!this.state.registro.mi_qtde) || (this.state.registro.mi_qtde === 0) || (this.state.registro.mi_qtde === '0')) {
      if ((!this.state.registro.pest_qtde === this.state.registro.mi_qtde)) {
        Modal.warning({ title: 'Aviso!', content: 'Quantidade contada precisa ser diferente da quantidade atual', });
        return;
      }
      if ((!this.state.registro.mi_vlr_total) || (this.state.registro.mi_vlr_total === 0) || (this.state.registro.mi_vlr_total === '0')) {
        Modal.warning({ title: 'Aviso!', content: 'Informe o Valor', });
        return;
      }
    }

    const registro = {
      mi_ent_sai: this.state.registro.mi_ent_sai,
      mi_item: this.state.registro.mi_item.pest_item,
      mi_item_tamanho: this.state.registro.mi_item.pest_tamanho,
      mi_item_cor: this.state.registro.mi_item.pest_cor,
      mi_qtde: this.state.registro.mi_qtde,
      mi_qtde_dif: this.state.registro.mi_qtde_dif,
      mi_vlr_unit: this.state.registro.mi_vlr_unit,
      mi_vlr_total: this.state.registro.mi_vlr_total,
    };

    // this.state.registro.mi_item_tamanho = this.state.registro.mi_item.pest_tamanho;
    // this.state.registro.mi_item_cor = this.state.registro.mi_item.pest_cor;
    // this.state.registro.mi_item = this.state.registro.mi_item.pest_item;

    axios.post('/estoque/storeInventario', registro)
      .then(response => {
        this.setState({
          formVisivel: false,
          salvando: false,
        })

        this.props.onInventarioClick();
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if (error.response.status === 412) {
          Modal.error({ title: 'Atenção', content: error.response.data, okText: 'OK', },
            this.props.onCancelarInventarioClick()
          )
        } else {
          Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível gravar. ' + error.response.data, okText: 'OK', },
            this.props.onCancelarInventarioClick()
          )
        }
      })

  };



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeProduto = event => {
    const { registro } = this.state;
    this.setState({
      registro: {
        ...registro,
        mi_item: event.mi_item,
        pest_qtde: parseFloat(event.mi_item.pest_qtde),
        mi_qtde: 0,
        mi_vlr_unit: parseFloat(event.mi_item.prod_vlr_custo),
        mi_vlr_total: 0,
      },
    });
  }

  onInputChangeQtde = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(value, this.state.registro.mi_vlr_unit);
  }

  onInputChangeVlrUnit = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
    this.calculoItem(this.state.registro.mi_qtde, value);
  }

  calculoItem = (mi_qtde, mi_vlr_unit) => {
    const vlrUnit = parseFloat(mi_vlr_unit);
    const qtde = parseFloat(mi_qtde);
    let mi_qtde_dif = 0;
    let mi_ent_sai = '';
    if (this.state.registro.pest_qtde > mi_qtde) {
      mi_ent_sai = 'S'
      mi_qtde_dif = this.state.registro.pest_qtde - mi_qtde;
    } else {
      mi_ent_sai = 'E'
      mi_qtde_dif = mi_qtde - this.state.registro.pest_qtde;
    }
    let mi_vlr_total = parseFloat(parseFloat(vlrUnit) * parseFloat(mi_qtde_dif));
    this.setState({
      registro: {
        ...this.state.registro,
        mi_ent_sai,
        mi_qtde_dif,
        mi_vlr_total,
      },
    });
  }


  render() {
    const { onCancelarInventarioClick, visivel } = this.props;
    const { mi_item, pest_qtde, mi_qtde, mi_qtde_dif, mi_vlr_unit, mi_vlr_total } = this.state.registro;

    // console.log('InventarioForm.this.state: ', this.state);

    return (
      <Modal
        title={"Ajuste de Estoque - Inventário"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarInventarioClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >


        <Row style={{}}>
          <Col xs={24} sm={24} style={{ marginLeft: 0 }}>
            <ProdutoFrame
              label="Produto"
              id="mi_item"
              value={mi_item}
              controlaEstoque={1}
              width={"100%"}
              onChange={this.onChangeProduto}
              // descricaoPrimeiroItem="Selecione um Produto"
            />
          </Col>

          <Col xs={24} sm={5} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <span>Qtde Atual</span>
            <InputForm
              type="number"
              id="pest_qtde"
              ref="pest_qtde"
              value={pest_qtde}
              onChange={this.onChange}
              disabled={true}
            />
          </Col>

          <Col xs={24} sm={5} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <span>Qtde Contada</span>
            <InputForm
              type="number"
              id="mi_qtde"
              ref="mi_qtde"
              value={mi_qtde}
              onChange={this.onInputChangeQtde}
            />
          </Col>

          <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <span>Diferença</span>
            <InputForm
              type="number"
              id="mi_qtde_dif"
              ref="mi_qtde_dif"
              value={mi_qtde_dif}
              onChange={this.onInputChangeQtde}
              disabled={true}
            />
          </Col>

          <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
            <span>Valor Unit</span>
            <InputForm
              type="number"
              id="mi_vlr_unit"
              ref="mi_vlr_unit"
              value={mi_vlr_unit}
              onChange={this.onInputChangeVlrUnit}
            />
          </Col>

          <Col xs={24} sm={6} style={{ marginTop: -20 }}>
            <span>Valor Total</span>
            <InputForm
              type="number"
              id="mi_vlr_total"
              ref="mi_vlr_total"
              value={mi_vlr_total}
              onChange={this.onChange}
            />
          </Col>

        </Row>


        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={this.onOK}
                  className="btn-salvar"
                  style={{ width: 130 }}
                >
                  Gravar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarInventarioClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InventarioForm.js